import Api from "../../../util/Api";

export default function getInitState() {
    return {
        gridIsOpen: true,
        selectedItems: [],
        formIsOpen: false,
        dataTableOptions: {
            server_mode: true,
            show_reset_button: false,
            checkbox_rows: true,
            global_search: {
                visibility: false,
            }
        },
        actions: [
            {
                btn_text: '<i class="fas fa-filter"></i> Szűrés',
                event_name: "customClick",
                class: "btn btn-primary my-custom-class",
                event_payload: 'showSearchModal'
            },
            {
                btn_text: '<i class="fas fa-plus"></i></i> Pácienshez rendelés',
                event_name: "customClick",
                class: "btn btn-info my-custom-class",
                event_payload: 'addToPatient'
            },
            {
                btn_text: '<i class="fas fa-plus"></i></i> Új tétel',
                event_name: "customClick",
                class: "btn btn-success my-custom-class",
                event_payload: 'newRow'
            },
        ],
        rowActions: [
            {
                btn_text: '<i class="fas fa-copy"></i>',
                title: 'Másolás',
                event_name: "customClick",
                class: "btn btn-outline-success",
                event_payload: 'copyRow'
            }, {
                btn_text: '<i class="fas fa-edit"></i>',
                title: 'Szerkesztés',
                event_name: "customClick",
                class: "btn btn-outline-primary",
                event_payload: 'modifyRow'
            }, {
                btn_text: '<i class="fas fa-trash"></i>',
                title: 'Törlés',
                event_name: "customClick",
                class: "btn btn-outline-danger",
                event_payload: 'deleteRow'
            }, {
                btn_text: '<i class="fas fa-undo"></i>',
                title: 'Visszaállítás',
                event_name: "customClick",
                class: "btn btn-outline-warning",
                seeCaseOfDeleted: true,
                event_payload: 'unDeleteRow'
            }
        ],
        searchFields: [
            {
                name: "name",
                label: "Név",
                visibility: true,
                formVisible: true,
                formSize: 3,
            },
            {
                name: "netPrice",
                label: "Nettó alapár",
                formType: "number",
                visibility: true,
                formVisible: true,
                formSize: 3,
            },
            {
                name: "vatKey",
                label: "ÁFA kulcs",
                visibility: true,
                formVisible: true,
                formSize: 3,
                formType: "select",
                selectOptions: {
                    apiCallback: Api.getAfaTipusList,
                    formatText: function (val) {
                        return val.text;
                    },
                    formatOption: function (val) {
                        return val.text;
                    },
                    minimumInputLength: 0,
                    searchOnServer: false,
                    filteredAttr: 'text',
                    returnValue: 'id',
                    locale: {
                        searchPlaceholder: 'Keresés...',
                        noResults: 'Nincs találat'
                    }
                }
            },
            {
                name: "grossPrice",
                label: "Bruttó ár",
                visibility: true,
                formType: "number",
                formVisible: true,
                formSize: 3,
            },
            {
                name: "teszorCode",
                label: "TESZOR kód",
                visibility: true,
                formVisible: true,
                formSize: 2,
                formType: 'select',
                selectOptions: {
                    apiCallback: Api.getAllTeszorCodes,
                    formatText: function (val) {
                        return val.text;
                    },
                    formatOption: function (val) {
                        return val.text;
                    },
                    minimumInputLength: 0,
                    searchOnServer: false,
                    filteredAttr: 'text',
                    returnValue: 'id',
                    locale: {
                        searchPlaceholder: 'Keresés...',
                        noResults: 'Nincs találat'
                    }
                }
            },
        ],
        headerFields: [
            {
                name: "name",
                label: "Név",
                visibility: true,
                formVisible: true,
                formRequired: true,
                formSize: 3,
            },
            {
                name: "netPrice",
                label: "Nettó alapár",
                formType: "number",
                visibility: true,
                formVisible: true,
                formRequired: true,
                formSize: 3,
                slot_name: "currencyFormat",
            },
            {
                name: "afaTipus.text",
                label: "ÁFA kulcs",
                visibility: true,
                formRequired: true,
                formVisible: true,
                formSize: 2,
                formType: "select",
                selectOptions: {
                    apiCallback: Api.getAfaTipusList,
                    formatText: function (val) {
                        return val.text;
                    },
                    formatOption: function (val) {
                        return val.text;
                    },
                    minimumInputLength: 0,
                    searchOnServer: false,
                    filteredAttr: 'text',
                    returnValue: 'id',
                    locale: {
                        searchPlaceholder: 'Keresés...',
                        noResults: 'Nincs találat'
                    }
                }
            },
            {
                name: "teszorCode.text",
                label: "TESZOR kód",
                visibility: true,
                formVisible: true,
                formRequired: true,
                formSize: 2,
                formType: 'select',
                selectOptions: {
                    apiCallback: Api.getAllTeszorCodes,
                    formatText: function (val) {
                        return val.text;
                    },
                    formatOption: function (val) {
                        return val.text;
                    },
                    minimumInputLength: 0,
                    searchOnServer: false,
                    filteredAttr: 'text',
                    returnValue: 'id',
                    locale: {
                        searchPlaceholder: 'Keresés...',
                        noResults: 'Nincs találat'
                    }
                }
            },
            {
                name: "grossPrice",
                label: "Bruttó ár",
                formRequired: true,
                visibility: true,
                formVisible: false,
                formType: "number",
                formSize: 2,
                slot_name: "currencyFormat1",
            },
            {
                name: "kaszCode",
                label: "KASZ kód",
                visibility: false,
                formVisible: true,
                formType: 'text',
                formSize: 2
            },
            {
                name: "buttons",
                label: "Opciók",
                sort: false,
                formVisible: false
            }

        ],
        formActions: [
            {
                btn_text: '<i class="fa fa-backward"></i> Vissza',
                event_name: "customClick",
                class: "btn btn-warning mx-1",
                event_payload: 'backToGrid'
            },
            {
                btn_text: '<i class="fas fa-trash"></i> Reset',
                event_name: "customClick",
                class: "btn btn-secondary mx-1",
                event_payload: 'resetForm'
            },
        ],
    }
}
